import React from 'react';
import { View } from 'react-native';
import Dimens from 'src/core/utils/Dimens';

type Props = {
	height?: number;
	width?: number;
};

function Gap({ height = Dimens.size0, width = Dimens.size0 }: Props) {
	return <View style={{ height, width }} />;
}

export default Gap;
